export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};

/**
 * @param choice number
 * @param choicesLength number
 * http://www.unicode.org/cldr/charts/latest/supplemental/language_plural_rules.html#ru
 */
export function pluralizationRules(choice, choicesLength) {
  let result = 3; //many
  if (choice === 0) {
    return 0; //Special case zero
  }

  const teen = (choice % 100) > 10 && (choice % 100) < 20;
  const digit = choice % 10;

  if (!teen && digit === 1) {
    result = 1; //one
  }

  if (!teen && digit >= 2 && digit <= 4) {
    result = 2; //few
  }

  return Math.min(result, choicesLength - 1);
};

export const messages = {
    "login.form.title": "Вход",
    "login.form.hint.user": "Имя для входа",
    "login.form.hint.password": "Пароль",
    "login.form.checkbox.remember-me": "Запомнить меня",
    "login.form.button.sign-in": "Вход",
    "login.form.message.invalid-user-credentials": "Неправильное имя пользователя или пароль",
    "login.form.message.user-required": "Введите имя входа",
    "login.form.message.password-required": "Введите пароль",
    "login.form.button.forgot-password": "Забыли пароль?",
    "error.root-admin-login.title": "Ошибка 403: запрещено",
    "error.root-admin-login.message": "Вы вошли в как администратор с правами только для чтения. Для доступа к консоли Web Recovery войдите с учетной записью клиента пользователя или администратора"
};
